import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { helpers } from 'styles'

export const Background = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	row-gap: 16px;
	background-color: ${helpers.color.pageHeader};
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	font-size: ${helpers.font.size.h1};
	color: ${helpers.color.white};
	padding: 32px;

	> svg {
		height: fit-content;
		width: 100%;
		max-width: 360px;
	}

	${mobileMediaQuery(css`
		max-height: 200px;
		font-size: ${helpers.font.size.larger};
		padding: 16px;

		> svg {
			max-width: 140px;
		}
	`)}
`
